import { produce } from 'immer';
import { orderBy } from 'lodash';

import { AddCreatedInternalProduct } from '../../../actions/products/internal/addCreatedInternalProduct';
import { routeToKeyMap } from '../../../service/ProductsHelpers';
import { Product, ProductsState } from '../../../typings/products';

export function addCreatedInternalProduct(state: ProductsState, action: AddCreatedInternalProduct): ProductsState {
    return produce(state, draft => {
        draft.products.push(action.product);

        if (action.sortParams) {
            draft.products = orderBy<Product>(
                draft.products,
                [routeToKeyMap[action.sortParams.key]],
                [action.sortParams.direction]
            );
        }

        draft.filtered = [];
        draft.isFiltered = false;
    });
}
